import { render, staticRenderFns } from "./RecordingIndication.vue?vue&type=template&id=2022c5ad&scoped=true&"
import script from "./RecordingIndication.vue?vue&type=script&lang=js&"
export * from "./RecordingIndication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2022c5ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2022c5ad')) {
      api.createRecord('2022c5ad', component.options)
    } else {
      api.reload('2022c5ad', component.options)
    }
    module.hot.accept("./RecordingIndication.vue?vue&type=template&id=2022c5ad&scoped=true&", function () {
      api.rerender('2022c5ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecordingIndication.vue"
export default component.exports